import { render, staticRenderFns } from "./AccountCheck.vue?vue&type=template&id=12836140"
import script from "./AccountCheck.vue?vue&type=script&lang=ts"
export * from "./AccountCheck.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports